import { ValidateLoginComponent } from './validateLogin/validatelogin.component';
import { ValidateSignUpComponent } from './validateSignUp/validateSignUp.component';
import { SignupComponent } from './signup/signup.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BaseRequestOptions, HttpModule } from '@angular/http';
import { MockBackend } from '@angular/http/testing';

import { AuthRoutingModule } from './auth-routing.routing';
import { AuthComponent } from './auth.component';
import { AlertComponent } from './_directives/alert.component';
import { LogoutComponent } from './logout/logout.component';
import { AuthGuard } from './_guards/auth.guard';
import { AlertService } from './_services/alert.service';
import { AuthenticationService } from './_services/authentication.service';
import { UserService } from './_services/user.service';
import { LoginService } from './../_services/index';
import { TooltipModule } from 'primeng/primeng';
import { LoaderPageComponent } from './loaderPage/loaderPage.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
    declarations: [
        AuthComponent,
        AlertComponent,
        LogoutComponent,
        SignupComponent,
        ValidateLoginComponent,
        ValidateSignUpComponent,
        LoaderPageComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        HttpModule,
        AuthRoutingModule,
        TooltipModule,
        HttpClientModule
    ],
    providers: [
        AuthGuard,
        AlertService,
        AuthenticationService,
        UserService,
        MockBackend,
        BaseRequestOptions,
        LoginService
    ],
    entryComponents: [AlertComponent],
})

export class AuthModule {
}


// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts